// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM4 6V4H20V6H4ZM16 15H13V18H11V15H8V13H11V10H13V13H16V15Z"}}]};

const TableAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-add-filled',
    ref,
    icon: element,
  },
));

TableAddFilledIcon.displayName = 'TableAddFilledIcon';

export default TableAddFilledIcon;
